module.exports = __webpack_public_path__ + "img/mindful_days_10--active.3cb154e4.svg";